import "./App.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { lazy, Suspense } from "react";

import Header from "./Utils/Header/Header";
import Loader from "./Utils/Loader/Loader";
import AbstractForm from "./Abstract/AbstractForm";
import Scientific from "./Scientific/Scientific";
import { BLOG_CATEGORY_LIST } from "./Blogs/blogCategories";

const Home = lazy(() => import(/* webpackChunkName: "Home" */ "./Home/Home"));

const About = lazy(() => import(/* webpackChunkName: "About" */ "./About/About"));

// const Events = lazy(() => import(/* webpackChunkName: "Events" */ "./Events/Events"));

const EventDetails = lazy(() => import(/* webpackChunkName: "Events" */ "./Events/EventDetails"));

const RegistrationForm = lazy(() => import(/* webpackChunkName: "Events" */ "./RegistrationForm/RegistrationForm"));

const FacultyReg = lazy(() => import(/* webpackChunkName: "Events" */ "./FacultyRegistration/FacultyReg"));

const Faculty = lazy(() => import(/* webpackChunkName: "Events" */ "./Faculty/Faculty"));

const FacultyDetail = lazy(() => import(/* webpackChunkName: "FacultyDetail" */ "./Faculty/FacultyDetail"));

const Research = lazy(() => import(/* webpackChunkName: "Events" */ "./Research/Research"));

const Cases = lazy(() => import(/* webpackChunkName: "Events" */ "./Cases/Cases"));

const CasesDetail = lazy(() => import(/* webpackChunkName: "Events" */ "./Cases/CasesDetail"));

const Gallery = lazy(() => import(/* webpackChunkName: "Notices" */ "./Gallery/Gallery"));

const Notices = lazy(() => import(/* webpackChunkName: "Notices" */ "./Notices/Notices"));

const Policy = lazy(() => import(/* webpackChunkName: "Policy" */ "./Policy/Policy"));

const Contact = lazy(() => import(/* webpackChunkName: "Contact" */ "./Contact/Contact"));

const BlogList = lazy(() => import(/* webpackChunkName: "Blogs" */ "./Blogs/BlogList"));

const BlogDetail = lazy(() => import(/* webpackChunkName: "Blogs" */ "./Blogs/BlogDetail"));

const ComingSoon = lazy(() => import(/* webpackChunkName: "ComingSoon" */ "./ComingSoon/ComingSoon"));

const theme = createTheme({
  palette: {
    primary: {
      main: "#86B73F",
    },
    secondary: {
      main: "#166E84",
    },
  },
});

const SuspenseLayout = () => (
  <>
    <Header />

    <Suspense
      fallback={
        <div className="loader-container">
          <Loader />
        </div>
      }>
      <Outlet />
    </Suspense>
  </>
);
function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route element={<SuspenseLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<ComingSoon />} />
            {/* <Route path="/event-details/:slug" element={<EventDetails />} />
            <Route path="/event/:slug/register" element={<RegistrationForm />} />
            <Route path="/event/:slug/abstract" element={<AbstractForm />} />
            <Route path="/event/:slug/scientific-program" element={<Scientific />} />
            <Route path="/event/:slug/faculty-register" element={<FacultyReg />} /> */}

            <Route path="/faculty" element={<Faculty />} />
            {/* <Route path="/faculty-details" element={<FacultyDetail />} /> */}

            {/* /research, /cases, /events: CMS blogs of that category, and their articles */}
            {BLOG_CATEGORY_LIST.map(({ key, href }) => (
              <Route key={key} path={href}>
                <Route index element={<BlogList categoryKey={key} />} />
                <Route path=":slug" element={<BlogDetail categoryKey={key} />} />
              </Route>
            ))}
            {/* <Route path="/cases-details" element={<CasesDetail />} /> */}

            {/* <Route path="/photo-gallery" element={<Gallery />} />
            <Route path="/notices" element={<Notices />} />
            <Route path="/policy/:name" element={<Policy />} /> */}
            <Route path="/contact" element={<ComingSoon />} />

            <Route path="/coming-soon" element={<ComingSoon />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
